
import ContentCast from "../components/ContentCast/ContentCast"
import Detail from "../components/Detail/Detail"
import Footer from "../components/Footer/Footer"

function Details(props){

    return(
        <>
        <Detail/>
        <ContentCast/>
        </>
    )
}

export default Details